/**
 * ESC "Default Department" (mirror_employee.dept, already mirrored) → Pegasus role.
 * Lets a tech's role default straight from ESC so the office never re-keys it; the
 * per-tech role <select> still overrides (override ⊕ derive, like the contact fields).
 *
 * Active crew today only spans 01/02/03/08 — those four are exact. 04/06/07/09 are
 * best-effort defaults for anyone reassigned there later (all overridable). ESC codes
 * (from the Employee dialog): 01 Install/Sales, 02 New Construction, 03 Service,
 * 04 Counter Sales, 06 Commercial Service, 07 Commercial Install, 08 Plumbing,
 * 09 Commercial Plumbing.
 */
export const DEPT_ROLE_NAME: Record<string, string> = {
  "01": "Installer", // Install / Sales
  "02": "New Construction",
  "03": "Service Technician",
  "04": "Office", // Counter Sales — no active techs; adjust if Seth wants a distinct role
  "06": "Service Technician", // Commercial Service
  "07": "Installer", // Commercial Install
  "08": "Plumbing",
  "09": "Plumbing", // Commercial Plumbing
};

/** The Pegasus role NAME a tech defaults to from their ESC department, or null. */
export const deptRoleName = (dept: string | null | undefined): string | null => {
  const d = (dept ?? "").trim();
  return d ? DEPT_ROLE_NAME[d] ?? null : null;
};
